import type { SelectProps } from 'antd'
import { Select } from 'antd'
import type React from 'react'
import { forwardRef } from 'react'

export type UiSelectProps = SelectProps

// forward ref xuống component Select của antd
const UiSelect = forwardRef<React.ComponentRef<typeof Select>, UiSelectProps>((props, ref) => {
  return <Select ref={ref} {...props} />
})

UiSelect.displayName = 'UiSelect'
export default UiSelect
